import { useContext, useState } from "react";
import { CloseButtonBig, HeaderWithButton, LoadButton, NavigateSmart, SquareButton } from "../common/Common";
import { LocaleContext, LoginContext, ScrollContext, StateContext } from "../common/App";
import './BePatient.css';
import { Navigate } from "react-router-dom";
import { LoadState, MediationStatus } from "../common/enums.mjs";
import { ConsumerContext } from "..";
import { get_translated_notifications, logout, logoutConsumer } from "../common/util";
import { useNavigateSmart } from "../common/hooks";

export function BePatient(props) {
    const state = useContext(StateContext);
    const locale = useContext(LocaleContext);
    const login = useContext(LoginContext);
    const consumer = useContext(ConsumerContext);
    const scroll = useContext(ScrollContext);

    const navigate = useNavigateSmart();

    const [loadState, setLoadState] = useState(LoadState.NONE);

    function handleLogoutClick() {
        try {
            logoutConsumer(state, login, consumer).then(() => {
                setLoadState(LoadState.LOAD_SUCCESS);
                navigate("/");
                scroll.scrollToPlain(0, 0);
            }).catch((error) => {
                console.log(error);
                setLoadState(LoadState.LOAD_ERROR);
            });

            // Calling setLoadState() after logoutConsumer() as it could throw an exception
            setLoadState(LoadState.LOADING);
		}
		catch(e) {
			console.log(e);
		}
    }

    if(consumer.mediationStatus !== MediationStatus.DATA_COLLECTED) {
        return <NavigateSmart to="/dashboard/"/>;
    }

    return(
        <div className="be_patient">
            <HeaderWithButton closeBtn={!consumer.declined} onClick={() => navigate("/")} langSelection={true} />

            <div className="margin_to_header"></div>

            { !consumer.declined ?
                <div className="be_patient_content side_padding">
                    <div className="head">{locale.msgs.BE_PATIENT}</div>
                    <div className="text">{locale.msgs.DONE_DESCR.replace("${{notifications}}", get_translated_notifications(login.notifications, locale))}</div>

                    <div id="be_patient_logout_btn_box">
                        <LoadButton text={locale.msgs.LOGOUT} clickable={true} onClick={handleLogoutClick}
                                errText={locale.msgs.ERROR} notSaved={loadState === LoadState.LOAD_ERROR}
                                saving={loadState === LoadState.LOADING} />
                    </div>
                </div>
            :
                null
            }
        </div>
    )
}
